import { render } from "./ImageItem.vue?vue&type=template&id=79e90b36&scoped=true&ts=true"
import script from "./ImageItem.vue?vue&type=script&lang=ts"
export * from "./ImageItem.vue?vue&type=script&lang=ts"

import "./ImageItem.vue?vue&type=style&index=0&id=79e90b36&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e90b36"]])

export default __exports__